import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import AccountIcon from 'console/left-menu/header/icons/account.svg';
import { Avatar } from '@mui/material';
import { removeNulls } from 'utils';
import { memo, useMemo } from 'react';
import { AnimatedAvatar } from 'console/left-menu/header/icons/animated-icon/animated-avatar';
import { useTheme } from '@mui/material/styles';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { NotAnimatedAvatar } from 'console/left-menu/header/icons/animated-icon/not_animated-avatar';
import { AnimElements, } from 'features/account.settings/model/animation-elements';
import { iconDefaultAccount } from 'console/left-menu/header/icons/default-icon';
import { ButtonSvgAnimation } from './button-stories/button-for-svg';
export const AvatarUser = memo(function AvatarUser(props) {
    const { is_vip, is_worker, has_user_paid_tariff, is_guest } = props;
    const animation_permissions_avatar = useAppSelector((state) => state.account.animation_permissions[AnimElements.avatar]);
    const theme = useTheme();
    const iconAccount = useMemo(() => [
        ...iconDefaultAccount(theme),
        {
            title: 'free',
            sx: {
                width: 32,
                height: 32,
                bgcolor: !is_guest ? undefined : 'warning.light',
            },
            component: _jsx(AccountIcon, { width: 26, height: 26 }),
        },
    ], [theme]);
    const status_account = useMemo(() => removeNulls(Object.entries({ is_vip, is_worker, has_user_paid_tariff }).map(([name_status, status]) => {
        if (!status) {
            return null;
        }
        return name_status;
    })), [is_vip, is_worker, has_user_paid_tariff]);
    return (_jsx(_Fragment, { children: status_account.length === 0 ? (iconAccount.map(({ title, sx, component }) => title === 'free' && (_jsx(ButtonSvgAnimation, { var_svg: true, children: _jsx(Avatar, { className: "profile", sx: sx, children: component }, title) }, title)))) : status_account.length === 1 ? (iconAccount.map(({ title, sx, component }) => title === status_account[0] && (_jsx(ButtonSvgAnimation, { var_svg: true, children: _jsx(Avatar, { className: 'profile', sx: sx, children: component }, title) }, title)))) : animation_permissions_avatar ? (_jsx(ButtonSvgAnimation, { var_svg: true, children: _jsx(AnimatedAvatar, { status_account: status_account }) })) : (_jsx(ButtonSvgAnimation, { var_svg: false, children: _jsx(NotAnimatedAvatar, { status_account: status_account }) })) }));
});
